import type { WsConnectionState } from '../../lib/ws-client.js';

export interface ConnectionStatusProps {
  readonly state: WsConnectionState;
}

export function ConnectionStatus({ state }: ConnectionStatusProps): JSX.Element | null {
  if (state === 'connected') return null;

  const failed = state === 'failed';
  const color = failed ? 'var(--color-red)' : 'var(--color-orange)';
  const label = failed ? 'Live updates failed' : 'Reconnecting…';

  return (
    <div
      role="status"
      className="flex items-center gap-2 px-2 py-1 rounded-md border"
      style={{
        borderColor: color,
        backgroundColor: failed ? 'rgba(224,82,82,0.08)' : 'rgba(244,128,60,0.08)',
      }}
    >
      <span
        aria-hidden
        className={failed ? '' : 'animate-spin'}
        style={{
          display: 'inline-block',
          width: 10,
          height: 10,
          borderRadius: '50%',
          border: `2px solid ${color}`,
          borderTopColor: 'transparent',
        }}
      />
      <span className="text-[11px] font-mono" style={{ color }}>
        {label}
      </span>
    </div>
  );
}
